import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const generateBillPDF = (name, period, totalAmount, payStatus, rows = [], columns = []) => {
  const doc = new jsPDF();

  doc.setFont("times", "bold");
  doc.setFontSize(16);
  doc.text("Orbsway Technologies Pvt. Ltd.", 70, 15);
  doc.setFontSize(10);
  doc.text("15th Floor, Building-23, DB Ozone, Dahisar, Mumbai- 400068", 56, 22);
  doc.text("Phone: +91-8433-936-127 | Email: help@orbsway.com", 66, 28);
  doc.line(10, 32, 200, 32); 

  doc.setFontSize(14);
  doc.setFont("times", "bold");
  doc.text("Billing Statement", 85, 42);
  doc.line(10, 46, 200, 46);

  doc.setFontSize(11);
  doc.setFont("times", "normal");
  doc.text(`Period: ${period}`, 10, 55);
  doc.text(`Amount: ${Number(totalAmount).toFixed(2)} INR`, 10, 63);
  doc.text(`Status: ${payStatus}`, 10, 71);
  doc.line(10, 75, 200, 75); 

  autoTable(doc, {
    startY: 80, 
    head: [columns.map(col => col.label)],
    body: rows.map(row => columns.map(col => row[col.id] || "-")),
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    headStyles: { fillColor: [60, 60, 60], textColor: [255, 255, 255] },
    alternateRowStyles: { fillColor: [240, 240, 240] },
  });

  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(10);
  doc.text("*Digital bill for reference purpose only", 75, pageHeight - 15);
  doc.line(10, pageHeight - 20, 200, pageHeight - 20);

  doc.save(`Orbsway_Bill_${name}_${period}.pdf`);
};

export default generateBillPDF;
